import React from 'react';
import PropTypes from 'prop-types';
import { ThreeImageGridStyles } from './ThreeImageGridStyles.styled';
import { formatHttpsUrl } from '@utils/utils';
import LinkWrapper from '../../LinkWrapper/LinkWrapper';
import { getContentfulApiVersion } from '@utils/config';

const ThreeImageGrid = ({ images, gtmDictionary }) => {
  const getImage = (id) => {
    const img = images[id];
    if (img) {
      return {
        url:
          getContentfulApiVersion() == 'v2'
            ? formatHttpsUrl(img.imageAsset?.file?.url + '?fm=webp')
            : formatHttpsUrl(img.imageAsset?.Fields?.file?.url + '?fm=webp'),
        altText: img.altText || '',
        linkURL: img.imageUrl,
        gtmClassName: (gtmDictionary && gtmDictionary[id]) || '',
      };
    }
  };

  const largeImage = getImage(0);
  const smallImageFirst = getImage(1);
  const smallImageSecond = getImage(2);

  return (
    <ThreeImageGridStyles
      urlLargeImage={largeImage?.url}
      urlSmallImageFirst={smallImageFirst?.url}
      urlSmallImageSecond={smallImageSecond?.url}
    >
      <section className="grid-container">
        <LinkWrapper
          className={`large-image ${largeImage?.gtmClassName}`}
          dataTestId="large-image"
          url={largeImage?.linkURL}
        >
          <span role="img" aria-label={largeImage?.altText}></span>
        </LinkWrapper>
        <LinkWrapper
          className={`small-image-first ${smallImageFirst?.gtmClassName}`}
          dataTestId="small-image-first"
          url={smallImageFirst?.linkURL}
        >
          <span role="img" aria-label={smallImageFirst?.altText}></span>
        </LinkWrapper>
        <LinkWrapper
          className={`small-image-second ${smallImageSecond?.gtmClassName}`}
          dataTestId="small-image-second"
          url={smallImageSecond?.linkURL}
        >
          <span role="img" aria-label={smallImageSecond?.altText}></span>
        </LinkWrapper>
      </section>
    </ThreeImageGridStyles>
  );
};

export default ThreeImageGrid;

ThreeImageGrid.propTypes = {
  images: PropTypes.array,
  gtmDictionary: PropTypes.array,
};
